export enum HttpStatus {
  Unauthorized = 401,
}
